import { observable, makeObservable, action } from "mobx";
import { api } from "../../../constants/apis";
import { get, post, put } from "../../../utils/axios-requests";

export default class ForgotPasswordUiStore {
  @observable error: string = '';

  constructor() {
    makeObservable(this);
  }

  @action
  public setError = (err: string) => {
    this.error = err;
  };

  @action
  public submitData = async (values: any) => {
    try {
      const res = await post(
        api.forgotPassword.all,
        {email: values.email}
      );

      if (res.status !== 200) {
        return null;
      }

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public getRequest = async (requestId: string) => {
    try {
      const res = await get(
        api.forgotPassword.single,
        {requestId}
      );

      if (res.status !== 200) {
        return false;
      }

      return true;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public confirmRequest = async (values: any, requestId: string) => {
    try {
      const res = await put(
        api.forgotPassword.single,
        {},
        {requestId},
        {password: values.password}
      );

      if (res.status !== 200) {
        return false;
      }

      return true;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };


}
